module.exports = __webpack_public_path__ + "bcd87fcdbcd4d08f7b4689960efc2499.pdf";